import CallRailSwap from 'services/multi-analytics/drivers/call-rail-swap';
import FacebookPixel from './drivers/facebook-pixel';
import GoogleAnalytics from './drivers/google-analytics';
import GoogleClickId from './drivers/google-click-id';
import MouseFlow from './drivers/mouse-flow';
import BingUET from './drivers/bing-uet';
import Segment from './drivers/segment';
import Pardot from './drivers/pardot';
import Hubspot from "./drivers/hubspot";

/**
 * Driver structure:
 *  key: Should match the name
 *  name: should match the key
 *  driver: should be a class implementing AbstractDriver
 */
export const DRIVERS = {
    FacebookPixel: {
        name: 'FacebookPixel',
        driver: FacebookPixel,
    },
    GoogleAnalytics: {
        name: 'GoogleAnalytics',
        driver: GoogleAnalytics,
    },
    GoogleClickId: {
        name: 'GoogleClickId',
        driver: GoogleClickId,
    },
    MouseFlow: {
        name: 'MouseFlow',
        driver: MouseFlow,
    },
    BingUET: {
        name: 'BingUET',
        driver: BingUET,
    },
    Segment: {
        name: 'Segment',
        driver: Segment,
    },
    Pardot: {
        name: 'Pardot',
        driver: Pardot,
    },
    CallRailSwap: {
        name: 'CallRailSwap',
        driver: CallRailSwap,
    },
    Hubspot: {
        name: 'Hubspot',
        driver: Hubspot,
    },
};

export const DEFAULT_DRIVERS = process.env.NODE_ENV === 'development'
    ? [
        DRIVERS.GoogleAnalytics.name,
        DRIVERS.FacebookPixel.name,
        DRIVERS.GoogleClickId.name,
        DRIVERS.CallRailSwap.name,
        DRIVERS.Hubspot.name,
    ]
    : [
        DRIVERS.GoogleAnalytics.name,
        DRIVERS.FacebookPixel.name,
        DRIVERS.GoogleClickId.name,
        DRIVERS.CallRailSwap.name,
        DRIVERS.Hubspot.name,
    ];
